import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash-es';
import { venomHistory } from 'client/utils/history/venom-history';
import { getVdpUrl } from 'site-modules/shared/utils/inventory-utils/get-vdp-url';
import { fireWidgetViewTracking } from 'site-modules/shared/utils/inventory/global-search-tracking';
import { FOUND_VIN_SCREEN_CREATIVE_ID } from 'site-modules/shared/constants/global-search/global-search';

export function vinDataProvider(WrappedComponent) {
  const Component = memo(({ componentParams = undefined, onSetLoadingStatus, searchId = undefined }) => {
    const foundVinInfo = componentParams?.identifiedVin?.vinInfo;

    useEffect(() => {
      if (isNil(foundVinInfo)) {
        onSetLoadingStatus(true);
        return;
      }

      fireWidgetViewTracking({
        value: `srp_search_id=${searchId}`,
        creativeId: FOUND_VIN_SCREEN_CREATIVE_ID,
      });

      venomHistory.replace(getVdpUrl({ inventory: foundVinInfo, radius: 0 }));
    }, [foundVinInfo, onSetLoadingStatus, searchId]);

    return <WrappedComponent />;
  });
  Component.displayName = 'VinDataProvider';
  Component.propTypes = {
    componentParams: PropTypes.shape({
      identifiedVin: PropTypes.shape({
        vinInfo: PropTypes.shape({}),
      }),
    }),
    onSetLoadingStatus: PropTypes.func.isRequired,
    searchId: PropTypes.string,
  };

  return Component;
}
